import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";

export const getAmbients = async () => { //obtener informacion de ambientes
  try {
    const { data } = await _axios.get("/api/ambients?sort=ambientNumber");
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const createLabMeasurement = async (props) => { //subir un registro de laboratorio
  //se necesita previamente la info de ambientes disponibles
  try {
    const response = await _axios.post("/api/labMeasurements", { ...props });
    return response;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }

}